export const ADVISOR_DRAWDOWN_NOTE_RECEIVED = 'ADVISOR_DRAWDOWN_NOTE_RECEIVED'
export const ADVISOR_DRAWDOWN_RECEIVED = 'ADVISOR_DRAWDOWN_RECEIVED'
export const ADVISOR_DRAWDOWN_SETTINGS_RECEIVED = 'ADVISOR_DRAWDOWN_SETTINGS_RECEIVED'
export const ADVISOR_DRAWDOWN_UNLOADED = 'ADVISOR_DRAWDOWN_UNLOADED'